'use client'

import Button from '@/components/ui/Button'
import Link from 'next/link'
import { signInWithEmail } from '@/utils/saas/auth-helpers/server'
import { handleRequest } from '@/utils/saas/auth-helpers/client'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

// Define prop type with allowPassword boolean
interface EmailSignInProps {
  allowPassword: boolean
  redirectMethod: string
  disableButton?: boolean
}

export default function EmailSignIn({
  allowPassword,
  redirectMethod,
  disableButton,
}: Readonly<EmailSignInProps>) {
  const tmpRouter = useRouter()
  const router = redirectMethod === 'client' ? tmpRouter : null
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    console.log('handleSubmit() - e=', e)
    setIsSubmitting(true) // Disable the button while the request is being handled
    await handleRequest(e, signInWithEmail, router)
    setIsSubmitting(false)
  }

  return (
    <div className="my-8">
      <form
        noValidate={true}
        className="mb-4"
        onSubmit={(e) => {
          // NOTE: Intentionally not awaited.
          void handleSubmit(e)
        }}
      >
        <div className="grid gap-2">
          <div className="grid gap-1">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              placeholder="name@example.com"
              type="email"
              name="email"
              autoCapitalize="none"
              autoComplete="email"
              autoCorrect="off"
              className="w-full p-3 rounded-md bg-theme-gray-200 dark:bg-theme-gray-800"
            />
          </div>
          <Button
            id="sign-in"
            variant="slim"
            type="submit"
            className="mt-1"
            loading={isSubmitting}
            disabled={disableButton}
          >
            {'Sign in'}
          </Button>
        </div>
      </form>
      {allowPassword && (
        <>
          <p>
            {/* @@TODO */}
            <Link
              href="/saas/signin/password_signin"
              className="font-light text-sm"
            >
              {'Sign in with email and password'}
            </Link>
          </p>
          <p>
            {/* @@TODO */}
            <Link href="/saas/signin/signup" className="font-light text-sm">
              {"Don't have an account? Sign up"}
            </Link>
          </p>
        </>
      )}
    </div>
  )
}
